exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".criteria-item[data-v-42d8a949]{margin:1rem}.criteria-item .criteria-item__main[data-v-42d8a949]{padding:1rem;border:1px solid rgba(0,0,0,.1);background:rgba(0,0,0,.05)}.criteria-item .criteria-item__info[data-v-42d8a949],.criteria-item .criteria-item__title[data-v-42d8a949]{display:flex;flex-direction:row;justify-content:space-between}", ""]);

// exports
